module.exports = __webpack_public_path__ + "img/banner_home.5453b111.png";